<template>
  <div>
    <box title="نقشه">
      <div slot="top-action-view">
        <v-btn
          dark
          outlined
          v-if="canAddNewLocation"
          @click="
            () => {
              newMarkerVisible = true;
              pnlSelectedMarkerVisible = false;
            }
          "
          >موقعیت جدید</v-btn
        >
      </div>
      <div class="pa-3">
        <v-row v-if="newMarkerVisible" class="mb-3">
          <v-col cols="6" sm="6" 
            ><v-text-field
              dense
              hide-details=""
              label="نام"
              outlined
              v-model="newMarkerName"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="6" class="pr-2"
            ><v-text-field
              dense
              hide-details=""
              label="lat"
              outlined
              v-model="centerMarker.lat"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="6" class="mt-2"
            ><v-text-field
              dense
              hide-details=""
              label="lng"
              outlined
              v-model="centerMarker.lng"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="6" class="pr-2 mt-2"
            ><v-text-field
              dense
              hide-details=""
              label="شعاع(متر)"
              outlined
              type="number"
              v-model="newRadius"
            ></v-text-field
          ></v-col>
          <v-col cols="12" class="pr-0 mt-2">
            <v-row>
              <v-col class="d-none d-sm-flex"></v-col>
              <v-col class="d-flex" cols="6" sm="auto"
                ><v-btn
                  class="my-auto"
                  block
                  color="primary"
                  @click="addNewMarker"
                  >افزودن
                </v-btn></v-col
              >
              <v-col class="pr-2" cols="6" sm="auto">
                <v-btn block color="primary" @click="newMarkerVisible = false"
                  >انصراف</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="pnlSelectedMarkerVisible" class="mb-3">
          <v-col cols="6" sm="3"
            ><v-text-field
              dense
              hide-details=""
              label="lat"
              outlined
              v-model="selectedMarker.lat"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="3" class="pr-2"
            ><v-text-field
              dense
              hide-details=""
              label="lng"
              outlined
              v-model="selectedMarker.long"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="3" class="pr-2"
            ><v-text-field
              dense
              hide-details=""
              label="شعاع"
              outlined
              type="number"
              v-model="selectedMarker.radius"
            ></v-text-field
          ></v-col>
          <v-col cols="6" sm="3" class="pr-2">
            <v-row>
              <!-- <v-col

                ><v-btn
                  block
                  color="primary"
                  @click="ModifyGeoLocation(selectedMarker)"
                >
                  <v-icon left>mdi-pencil</v-icon>
                  ویرایش
                </v-btn></v-col
              > -->
              <v-col class="pr-2">
                <v-btn
                  block
                  color="primary"
                  @click="DeleteGeoLocation(selectedMarker)"
                >
                  <v-icon left>mdi-delete</v-icon>

                  حذف</v-btn
                ></v-col
              >
            </v-row>
          </v-col>
        </v-row>

        <v-row class="h-100" style="height: 85vh">
          <v-col>
            <l-map
              :options="mapOptions"
              style="z-index: 0"
              :zoom="zoom"
              :center="center"
              @update:center="centerUpdate"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-control-attribution
                :position="'bottomright'"
                :prefix="'www.elmosanat.com'"
              />
              <div v-if="newMarkerVisible">
                <l-marker draggable :lat-lng.sync="centerMarker">
                  <l-icon
                    class="new-marker"
                    :icon-size="[50, 50]"
                    :icon-url="require('@/assets/icons/pin-location.svg')"
                  ></l-icon>
                </l-marker>
                <l-circle :lat-lng="centerMarker" :radius="newRadius" />
              </div>
              <div v-if="markerList.length > 0">
                <div v-for="(marker, i) in markerList" :key="i">
                  <l-marker
                    :lat-lng="getMarkerLatLng(marker)"
                    @click="onClickMarker(marker)"
                  ></l-marker>
                  <l-circle
                    :lat-lng="getMarkerLatLng(marker)"
                    :radius="marker.radius"
                  />
                </div>
              </div>
            </l-map>
          </v-col>
        </v-row>
      </div>
    </box>
  </div>
</template>

<script>
// If you need to reference 'L', such as in 'L.icon', then be sure to
// explicitly import 'leaflet' into your component
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LControlAttribution,
  LCircle,
  LIcon,
} from "vue2-leaflet";
import ResultType from "../../../model/ResultType";
import EosToastType from "../../../model/EosToastType";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControlAttribution,
    LCircle,
    LIcon,
  },
  data() {
    return {
      zoom: 12,
      center: L.latLng(35.687656, 51.388546),
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      marker: L.latLng(35.687656, 51.388546),
      attribution: "",
      mapOptions: {
        zoomControl: true,
        attributionControl: false,
        zoomSnap: true,
      },
      centerMarker: "",
      newLat: "",
      newLng: "",
      newRadius: 100,
      newMarkerName: "",
      newMarkerVisible: false,
      pnlSelectedMarkerVisible: false,
      selectedMarker: {},
      markerList: [],
      canAddNewLocation: false,
    };
  },
  mounted() {
    this.centerMarker = this.center;
    this.GetGeoLocation();
  },
  methods: {
    latLng(lat, lng) {
      return L.latLng(lat, lng);
    },
    centerUpdate(center) {
      this.center = center;
      this.centerMarker = center;
      this.pnlSelectedMarkerVisible = false;
    },
    getMarkerLatLng(marker) {
      return L.latLng(marker.lat, marker.long);
    },
    GetGeoLocation() {
      this.$store.dispatch("geolocation/GetGeoLocation").then((result) => {
        console.log(result);
        if (result.type == ResultType.success) {
          this.markerList = result.data;
          var GeoFenceCount = this.$store.state.lock.lockData.GeoFenceCount;
          if (GeoFenceCount && Number(GeoFenceCount) > this.markerList.length) {
            this.canAddNewLocation = true;
          } else {
            this.canAddNewLocation = false;
          }
        }
      });
    },
    getNewMarkerIcon() {
      /*var item = {
        color: "#000",
        strokeColor: "#00000000",
        circleColor: "#000",
      };*/
      return L.divIcon({
        className: "my-custom-pin",
      });
    },
    addNewMarker() {
      var GeoFenceCount = this.$store.state.lock.lockData.GeoFenceCount;
      if (GeoFenceCount && Number(GeoFenceCount) > this.markerList.length) {
        this.canAddNewLocation = true;
      } else {
        this.canAddNewLocation = false;
      }

      if (!this.canAddNewLocation) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "بیشتر از حد مجاز نمیتوانید موقعیت جدید ثبت نمایید",
        });
        return;
      }

      if (!this.newMarkerName) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "یک نام برای موقعیت مورد نظر وارد نمایید",
        });
        return;
      }

      this.$store
        .dispatch("geolocation/AddGeoLocation", {
          data: {
            lat: this.centerMarker.lat,
            lng: this.centerMarker.lng,
            radius: this.newRadius,
            name: this.newMarkerName,
          },
        })
        .then((result) => {
          console.log(result);
          if (result.type == ResultType.success && result.data) {
            this.newMarkerVisible = false;
            this.$EosToast.show({
              type: EosToastType.success,
              msg: "موقعیت جدید با موفقیت اضافه شد",
            });
            this.GetGeoLocation();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: "خطا در انجام عملیات",
            });
          }
        });
    },
    onClickMarker(marker) {
      console.log(marker);
      this.selectedMarker = marker;
      this.pnlSelectedMarkerVisible = true;
      this.newMarkerVisible = false;
    },
    DeleteGeoLocation(selectedMarker) {
      //console.log(selectedMarker);
      this.$store
        .dispatch("geolocation/DeleteGeoLocation", {
          params: {
            id: selectedMarker.id,
          },
        })
        .then((result) => {
          console.log(result);
          if (result.type == ResultType.success && result.data) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: "موقعیت جدید با موفقیت حذف شد",
            });
            this.GetGeoLocation();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: "خطا در انجام عملیات",
            });
          }
        });
    },
    ModifyGeoLocation(selectedMarker) {
      console.log(selectedMarker);
      this.$store
        .dispatch("geolocation/ModifyGeoLocation", {
          data: {
            id: selectedMarker.id,
            lat: this.centerMarker.lat,
            lng: this.centerMarker.lng,
            radius: this.newRadius,
          },
        })
        .then((result) => {
          console.log(result);
          if (result.type == ResultType.success && result.data) {
            this.newMarkerVisible = false;
            this.$EosToast.show({
              type: EosToastType.success,
              msg: "موقعیت جدید با موفقیت اضافه شد",
            });
            this.GetGeoLocation();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: "خطا در انجام عملیات",
            });
          }
        });
    },
  },
};
</script>

<style>
.new-marker {
  color: rgb(208, 255, 0);
}
</style>